export default function () {
    const $sidebar = $('.sidebar-sticky');

    if (!$sidebar.length) {
        return;
    }

    const $window = $(window);
    const $sidebarHeight = $sidebar.innerHeight();
    const $footerOffsetTop = $('.footer').offset().top;
    const $sidebarOffset = $sidebar.offset();

    $window.scroll(() => {
        if ($window.scrollTop() + 90 > $sidebarOffset.top) {
            $sidebar.addClass('sticky');
        } else {
            $sidebar.removeClass('sticky');
        }

        if ($window.scrollTop() + $sidebarHeight > $footerOffsetTop) {
            $sidebar.css({
                top: -($window.scrollTop() + $sidebarHeight - $footerOffsetTop),
            });
        } else {
            $sidebar.css({
                top: '30px',
            });
        }
    });
}
